import BaseParser from './BaseParser';
import _get from 'lodash/get';
import { filterCodings } from './util';
import { BaseParserOptions, CodeableConceptOptions } from './SharedTypes';

class CodeableConcept extends BaseParser {
  private options: BaseParserOptions;

  /**
   * @param {string|string[]} options.codeableConcept.system - the target system or list of target systems
   * @param {string|string[]} options.codeableConcept.code - the target code or list of target codes
   */
  constructor(options: BaseParserOptions = {}) {
    super();
    this.options = options;
  }

  // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
  getDisplayValue(fhirProperty: fhir.CodeableConcept) {
    if (!fhirProperty) return null;

    const codings = _get<fhir.CodeableConcept, 'coding', fhir.Coding[]>(
      fhirProperty,
      'coding',
      [],
    );
    const text = _get<fhir.CodeableConcept, 'text', 'string'>(
      fhirProperty,
      'text',
      // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
      null,
    );

    if (!codings || codings.length === 0) return text;

    const codeableConceptOptions =
      _get<BaseParserOptions, 'codeableConcept', CodeableConceptOptions>(
        this.options,
        'codeableConcept',
        {},
      ) || {};
    const { system, code } = codeableConceptOptions;

    // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
    const targetCoding = filterCodings(codings, system, code);
    if (!targetCoding) return text;

    const targetCodingCode = _get<fhir.Coding, 'code', string>(
      targetCoding,
      'code',
      // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
      null,
    );
    const targetCodingDisplay = _get<fhir.Coding, 'display', string>(
      targetCoding,
      'display',
      // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
      null,
    );
    return targetCodingDisplay || text || targetCodingCode;
  }
}

export default CodeableConcept;
